// removed by extract-text-webpack-plugin
module.exports = {"tags":"src-components-Tags----tags-module---tags---rcuIT","tag":"src-components-Tags----tags-module---tag---2kJvP src-components-Nav----nav-module---tag---2286F src-components-Nav----nav-module---button---7wpvU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tags/tags.module.sass
// module id = 366
// module chunks = 195351340454287